import React, { useEffect, useState } from "react";
import { Trophy, ExternalLink } from "lucide-react";
import SectionLabel from "@/components/SectionLabel";
import { getTopDepositors } from "@/lib/api";
import { config } from "@/config";

const shortAddr = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "-");
const MEDALS = { 1: "🥇", 2: "🥈", 3: "🥉" };

export default function TopHolders() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const run = () => getTopDepositors().then(setData).catch(() => {});
    run();
    const t = setInterval(run, 30000);
    return () => clearInterval(t);
  }, []);

  const top = data?.top || [];
  const byRank = {};
  top.forEach((h) => { byRank[h.rank] = h; });
  const rows = Array.from({ length: 10 }, (_, i) => {
    const rank = i + 1;
    return byRank[rank] || { rank, address: null, usdt: 0 };
  });

  return (
    <div className="px-1 pb-4">
      <SectionLabel center>Top Depositors · today (UTC)</SectionLabel>

      {/* Top 10 (current cycle · resets 00:00 UTC) */}
      <div className="card-glow p-4">
        <div className="mb-3 flex items-center justify-between">
          <span className="flex items-center gap-1.5 text-xs font-semibold text-[#34D07A]">
            <Trophy size={14} /> Top Depositors · today (UTC)
          </span>
          <span className="text-[11px] text-white/40">{top.length} ranked</span>
        </div>
        <div className="grid grid-cols-[0.6fr_1.4fr_1fr] items-center gap-2 border-b border-white/5 pb-2 text-[10px] font-semibold uppercase tracking-wide text-[#D6C51E]">
          <span>Rank</span><span>Address</span><span className="text-right">USDT</span>
        </div>
        {rows.map((h) => {
          const num = String(h.rank).padStart(2, "0");
          return (
            <div key={h.rank} data-testid={`top-row-${h.rank}`} className="grid grid-cols-[0.6fr_1.4fr_1fr] items-center gap-2 border-t border-white/5 px-1 py-2.5 text-xs">
              <span className="flex items-center gap-1 font-semibold text-[#34D07A]">
                <span className="tabular-nums text-white/50">{num}</span>
                {h.rank <= 3 && <span className="text-base leading-none">{MEDALS[h.rank]}</span>}
              </span>
              {h.address ? (
                <a
                  data-testid={`top-link-${h.rank}`}
                  href={h.tx_hash ? `${config.explorer}/tx/${h.tx_hash}` : `${config.explorer}/address/${h.address}`}
                  target="_blank"
                  rel="noreferrer"
                  className="flex min-w-0 items-center gap-1.5 font-mono text-[#34D07A] active:opacity-80"
                >
                  <span className="truncate">{shortAddr(h.address)}</span>
                  <ExternalLink size={12} className="shrink-0" />
                </a>
              ) : (
                <span className="font-mono text-white/25">—</span>
              )}
              <span className="text-right font-semibold">
                {h.address ? (
                  <span className="text-[#34D07A]">${h.usdt} <span className="text-[#D6C51E]">USDT</span></span>
                ) : (
                  <span className="text-white/25">—</span>
                )}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
